function download(url, filename) {
  const link = document.createElement("a");
  link.download = filename || url.split("/").pop();
  link.href = url;
  link.target = "_blank";

  link.click();
}

export { download };
